export default __webpack_public_path__ + "static/media/alphabet-yellow-exclamation.20d2658b.png";